import * as React from "react";
import styled, { css } from "styled-components";

import Image from "../../common/components/Image";

export type Avatar = WtdModels.Partial<WtdModels.Image, "url">;

interface Props {
  className?: string;
  avatar: Avatar;
  index: number;
  allCountOfAvatars: number;
}

const MembershipSectionCoverImage: React.SFC<Props> = props => {
  const { avatar } = props;

  return <Image className={props.className} image={avatar} size="115x115#" background={true} />;
};

const OverallImageStyle = css`
  width: 100%;
  height: 100%;
`;

const HarfImageStyle = css`
  width: 50%;
  height: 100%;
`;

const QuarterImageStyle = css`
  width: 50%;
  height: 50%;
`;

const StyledMembershipSectionCoverImage = styled(MembershipSectionCoverImage)`
  background-size: cover;
  background-position: center;
  ${props => {
    switch (props.allCountOfAvatars) {
      case 1:
        return OverallImageStyle;
      case 2:
        return HarfImageStyle;
      case 3:
        return props.index === 0 ? HarfImageStyle : QuarterImageStyle;
      case 4:
        return QuarterImageStyle;
      default:
        return "";
    }
  }};
`;

export default StyledMembershipSectionCoverImage;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipSectionCoverImage.tsx